import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { remCalc } from '../../../util/style-util';

const BasicButton: any = ({
  children,
  text,
  icon: Icon,
  buttonStyles = [],
  disabled,
  color,
  fill,
  hoverFill,
  ...props
}) => {
  const buttonContent: any = text || children;
  const { basicButton, disabledClass } = useStyles({ color, fill, hoverFill });

  return (
    <button className={clsx(basicButton, ...buttonStyles, disabled && disabledClass)} {...props}>
      {Icon ? <Icon /> : buttonContent}
    </button>
  );
};

const useStyles = makeStyles(() => ({
  basicButton: ({ color, fill, hoverFill }: any) => ({
    backgroundColor: fill,
    border: 'none',
    padding: remCalc(10),
    fontSize: '16px !important',
    fontWeight: 600,
    color,
    '&:hover': {
      backgroundColor: hoverFill!
    },
    '&:focus': {
      color
    }
  }),
  disabledClass: ({ fill }: any) => ({
    cursor: 'not-allowed',
    pointerEvents: 'none',
    opacity: 0.6,
    '&:hover': {
      backgroundColor: fill
    }
  })
}));

BasicButton.defaultProps = {
  color: 'black',
  fill: 'transparent',
  buttonStyles: []
};

export default BasicButton;
